import { motion, useReducedMotion } from "framer-motion";

// Sanftes, dezentes Einblenden beim Scrollen (barrierefrei: respektiert reduced-motion)
export const FadeIn = ({ children, delay = 0, y = 24, className = "", ...props }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default FadeIn;
